var _ellipse, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 309,
    viewBox: "0 0 302 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151,
    cy: 154.5,
    rx: 151,
    ry: 154.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.417 184.484V243.418H231.001V251.835H79.4587V243.418H71.042V184.484H129.975V201.318H180.484V184.484H239.417Z",
    fill: "#030659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.067 184.484H138.4V192.9H172.067V184.484ZM172.067 167.65H138.4V176.067H172.067V167.65Z",
    fill: "#030659"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.417 100.292V91.875H188.9V75.0417H180.484V66.625H129.975V75.0417H121.559V91.875H71.0417V100.292H62.625V167.65H71.0417V176.067H129.975V159.234H180.484V176.067H239.417V167.65H247.834V100.292H239.417ZM138.392 83.4583H172.067V91.875H138.392V83.4583Z",
    fill: "#030659"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAvatar);
export default __webpack_public_path__ + "static/media/companyAvatar.e1cbd5947feaea9175977d11c8448c6f.svg";
export { ForwardRef as ReactComponent };